var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"theme",rawName:"v-theme",value:('form.button'),expression:"'form.button'"}],staticClass:"flex justify-center items-center w-full px-2 py-2 rounded-md text-center",attrs:{"href":_vm.editUrl}},[_c('app-icon',{staticClass:"mr-2 h-5 w-5",attrs:{"name":"edit"}}),_vm._v("\n    "+_vm._s(_vm.$t('button-edit-reply'))+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }